import { lazy, Suspense, useState } from 'react';
import type { DrawerProps } from './Drawer';
import { loadDrawer } from './drawer-loader';

const Drawer = lazy(loadDrawer);

/**
 * A `Drawer` whose code (Radix Dialog, the scroll lock, focus management) is fetched when it is first wanted, not
 * with the page: a sheet that is closed costs nothing, and most visitors never open it. From the first opening it
 * stays mounted — closed, it renders nothing — so Radix can play the closing animation.
 */
export function LazyDrawer(props: DrawerProps) {
  const [wanted, setWanted] = useState(props.open);
  if (props.open && !wanted) setWanted(true);
  if (!wanted) return null;
  return (
    <Suspense fallback={null}>
      <Drawer {...props} />
    </Suspense>
  );
}
